import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { getLenderInfoAsync } from '../../../API/lenders/LendersAPI';
import {
  actionLenderUsersAsync,
  addLenderUsersAsync,
  editLenderUsersAsync,
  getLenderUsersAsync,
} from '../../../API/lenders/LenderContactsAPI';
import { createAsyncSlice } from '../../createAsyncSlice';
import { createKeyedDataAsyncSlice } from 'store/createKeyedDataAsyncSlice';

// LENDER INFO

export const { slice: getLenderInfoSlice, asyncAction: getLenderInfoAction } = createKeyedDataAsyncSlice(
  'getLenderInfo',
  getLenderInfoAsync,
  (t) => t,
);

//LENDER CONTACTS

export const { slice: lenderContactsSlice, asyncAction: getLenderContactsAction } = createAsyncSliceWithDataAndQuery(
  'lenderContacts',
  getLenderUsersAsync,
  []
);

export const { slice: addLenderContactSlice, asyncAction: addLenderContactAction } = createAsyncSlice(
  'addLenderContact',
  addLenderUsersAsync
);

export const { slice: editLenderContactSlice, asyncAction: editLenderContactAction } = createAsyncSlice(
  'editLenderContact',
  editLenderUsersAsync
);

export const { slice: actionLenderContactSlice, asyncAction: actionLenderContactsAction } =
  createAsyncSliceWithDataAndQuery('actionClientContact', actionLenderUsersAsync, {} as any);
